// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * User-preferences types — mirror of the backend schema
 * (`modules/preferences/schema.py` / the preferences Lambda), in the API's
 * camelCase shape. All fields optional; unset means "no preference".
 */

// Caps — must match the backend schema.
export const NOTAS_LIBRES_MAX = 500
export const NOMBRE_MAX = 80

export type Tono = "ejecutivo-conciso" | "detallado"
export type FormatoRespuesta = "prosa" | "bullets"
export type Desambiguacion = "siempre" | "estandar" | "minima"
export type LongitudRespuesta = "breve" | "estandar" | "detallada"

/** A single user's steering preferences (camelCase API shape). */
export interface UserPreferences {
  activo: boolean
  nombre: string | null
  tono: Tono | null
  formatoRespuesta: FormatoRespuesta | null
  desambiguacion: Desambiguacion | null
  longitudRespuesta: LongitudRespuesta | null
  notasLibres: string | null
}

/** Return a preferences document with nothing set. */
export function emptyPreferences(): UserPreferences {
  return {
    activo: false,
    nombre: null,
    tono: null,
    formatoRespuesta: null,
    desambiguacion: null,
    longitudRespuesta: null,
    notasLibres: null,
  }
}

/** An option value paired with its Spanish display label (for chip groups). */
export interface PrefOption<T extends string> {
  value: T
  label: string
}

export const TONO_OPTIONS: PrefOption<Tono>[] = [
  { value: "ejecutivo-conciso", label: "Ejecutivo y conciso" },
  { value: "detallado", label: "Detallado" },
]
export const FORMATO_OPTIONS: PrefOption<FormatoRespuesta>[] = [
  { value: "prosa", label: "Prosa" },
  { value: "bullets", label: "Bullets" },
]
export const DESAMBIGUACION_OPTIONS: PrefOption<Desambiguacion>[] = [
  { value: "siempre", label: "Siempre pregunta" },
  { value: "estandar", label: "Estándar" },
  { value: "minima", label: "Mínima" },
]
export const LONGITUD_OPTIONS: PrefOption<LongitudRespuesta>[] = [
  { value: "breve", label: "Breve" },
  { value: "estandar", label: "Estándar" },
  { value: "detallada", label: "Detallada" },
]
